import React from 'react'
import { WidgetContent, Divider } from '@duik/it'
import { ModalButton } from '../UI/ModalButton'
import ErrorIcon from '@material-ui/icons/Error'
import styled from '@emotion/styled'
import Widget from './Widget'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`

const WidgetWrapper = styled.div`
  max-width: 480px;
  max-height: 180px;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 5px;
`

const StyledWidget = styled(Widget)`
  height: 100%;
`

const WidgetContentWrapper = styled(Widget)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
`

const StyledWidgetContent = styled(WidgetContent)`
  display: flex;
  justify-content: space-between;
`

const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledErrorIcon = styled(ErrorIcon)`
  color: #e6492d;
  padding-left: 30px;
  font-size: 35px;
`

const Title = styled.h3`
  margin: 25px;
  color: #3e3f42;
`

const Message = styled.p`
  font-size: 14px;
  color: #6b6c6f;
`

const ModalButtonWrapper = styled.div`
  width: 83px;
`

type Props = {
  title: string
  handleOk(): void
  message: any | null
}

const CreateNewErrorModal = ({ title, handleOk, message }: Props) => (
  <Container>
    <WidgetWrapper>
      <StyledWidget>
        <ErrorWrapper>
          <StyledErrorIcon />
          <Title>{title}</Title>
        </ErrorWrapper>
        <Divider />
        <WidgetContentWrapper>
          <Message>{message}</Message>
          <StyledWidgetContent>
            <ModalButtonWrapper>
              <ModalButton success type="submit" onClick={handleOk} name="OK" />
            </ModalButtonWrapper>
          </StyledWidgetContent>
        </WidgetContentWrapper>
      </StyledWidget>
    </WidgetWrapper>
  </Container>
)

CreateNewErrorModal.defaultProps = {
  title: ''
}

export default CreateNewErrorModal
